var map = {
	"./active-card.svg": 4439,
	"./add-card/card-full.svg": 1939,
	"./add-card/new-card.svg": 6828,
	"./add-card/sbp-banks/alfa.svg": 7931,
	"./add-card/sbp-banks/ozon.svg": 1991,
	"./add-card/sbp-banks/qiwi.svg": 4745,
	"./add-card/sbp-banks/sberbank.svg": 6807,
	"./add-card/sbp-banks/tinkoff.svg": 7514,
	"./add-card/sbp-banks/tinkoffOLD.svg": 3193,
	"./add-card/sbp-banks/tochka.svg": 9925,
	"./add-card/sbp-banks/vtb.svg": 8213,
	"./add-card/sbp-banks/wb.svg": 1364,
	"./add-card/sbp-color.svg": 2684,
	"./add-card/sbp-inactive.svg": 9804,
	"./add-card/sbp.svg": 2778,
	"./blocking.svg": 3473,
	"./card.svg": 2312,
	"./check_icon.svg": 4834,
	"./close.svg": 8298,
	"./edit-card-icon.svg": 4717,
	"./edit-card.svg": 6998,
	"./general/connection_lost.svg": 7210,
	"./general/email.svg": 615,
	"./general/error.svg": 2813,
	"./general/install-app.svg": 3648,
	"./general/max-black.svg": 5187,
	"./general/max.svg": 21,
	"./general/tg.svg": 7758,
	"./general/wa.svg": 4617,
	"./icons/comission1.svg": 3578,
	"./icons/comission2.svg": 4953,
	"./icons/sbp.svg": 1636,
	"./logo.svg": 7503,
	"./qiwi.svg": 3460,
	"./qrc_payment.svg": 9149,
	"./qrc_paymentBlue.svg": 6985,
	"./ruble-vector.svg": 7024,
	"./sbp.svg": 787,
	"./store/download.svg": 4988,
	"./store/rating-no-fill.svg": 4165,
	"./store/rating.svg": 5083,
	"./store/safari.svg": 7244,
	"./story/sbp/preview.svg": 6456,
	"./taxi-car.svg": 8500,
	"./tinkoff-card.svg": 7268,
	"./trash.svg": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;